// 用户已授权临时中文。这里是功能内的普通文案，不是 Smartcat key；正式下发后通过 copy 替换。
export const temporaryMyIpUnavailableReason = '暂未接入';

// 资源预览临时中文；未知包装与解析失败不使用「空资源」文案掩盖。
export const temporaryMyIpMediaCopy = {
  generateCard: '生成IP角色卡片',
  /** 画布 IP card 多选上限提示。 */
  selectionLimit: '最多选择47个素材',
  /** 更多素材存储上限提示（用例口径）。 */
  materialLimit: '保存失败，已达到数量上限',
  settings: '基础设定',
  more: '更多素材',
  filter: '素材类型',
  all: '全部',
  image: '图片',
  video: '视频',
  audio: '音频',
  unknown: '素材',
  preview: '素材预览',
  close: '关闭预览',
  enlargeMain: '放大查看主图',
  enlargeThreeView: '放大查看三视图',
  unavailable: '素材暂不可用',
  unsupported: '部分历史素材格式暂不支持展示，原始数据未修改。',
  empty: {
    all: '暂时还没有素材资源', image: '暂时还没有图片资源', video: '暂时还没有视频资源', audio: '暂时还没有音频资源', unknown: '暂时还没有素材资源',
  },
};

/** 角色卡生成与下载弹窗临时中文，正式文案优先复用 Smartcat 已有 key。 */
export const temporaryMyIpRoleCardCopy = {
  title: 'IP角色卡',
  view: '查看IP角色卡',
  empty: '目前还没有IP角色卡',
  close: '关闭角色卡',
  loading: '加载角色卡…',
  loadError: '角色卡加载失败，请重试',
  retry: '重试',
  scanHint: '扫码查看角色',
  coverUnavailable: '封面暂不可用',
  saveToLocal: '保存到本地',
  saveError: '保存失败，请重试',
};

const sharedCopy = {
  loading: '加载中…',
  retry: '重试',
  loadError: '加载失败，请重试',
  actionError: '操作失败，请重试',
  createWithIp: '为TA创作',
  coverUnavailable: '封面暂不可用',
  /** 临时中文直接格式化真实项目数，不借用或伪造翻译 key。 */
  formatProjectCount: (count: number) => `已创作 ${count} 个项目`,
};

// 资产库沿用同一份临时中文，不将「旧角色素材」翻译 key 冒充 IP 分类。
export const temporaryMyIpAssetCopy = {
  networkError: '网络异常，请重试',
  searchPersonal: '搜索我的IP角色',
  ...sharedCopy,
  title: '角色IP',
  create: '新建IP',
  createDescription: '创建一个新的角色IP资产',
  search: '搜索IP角色',
  searchAction: '搜索',
  noMatch: '没有匹配素材',
  empty: '暂无角色IP',
  detail: '素材详情',
  close: '关闭素材详情',
  viewSettings: '查看设定',
  applyToCanvas: '应用到画布',
  loadMore: '加载更多',
  loginRequired: '请登录后查看角色IP',
  creationUnavailable: 'IP 创建暂未接入',
};

export const temporaryMyIpListCopy = {
  ...sharedCopy,
  title: '我的角色IP',
  ipCount: 'IP形象',
  cumulativeProjectCount: '累计项目',
  createTitle: '创建新的角色IP',
  createDescription: '上传形象或用文字描述，生成完整设定',
  empty: '暂无数据',
  loadMore: '加载更多',
};

export const temporaryMyIpDetailCopy = {
  ...sharedCopy,
  back: '返回我的角色IP',
  invalidIp: '角色IP链接无效',
  notFound: '角色IP不存在或已删除',
  forbidden: '暂时无法访问该IP',
  privateDescription: '该IP为个人私用资产，仅创建者本人可查看。',
  returnHome: '返回首页',
  /** 顶栏进入 Agent 创作页；与设定栏铅笔（文本设定）不同入口。 */
  editAgent: '编辑',
  identity: '身份',
  characterSettings: '角色设定',
  visualAndAppearance: '视觉与外形',
  threeViews: '三视图',
  appearance: '外形特征',
  visualStyle: '视觉风格',
  personalityAndSetting: '性格与设定',
  personality: '性格特点',
  speechStyle: '语言风格',
  backstory: '角色故事',
  relatedProjects: '关联项目',
  noProjects: '暂无关联项目',
  loadMoreProjects: '加载更多项目',
  playVoice: '播放音色',
  pauseVoice: '暂停音色',
  mediaError: '媒体暂不可用，请重试',
  voiceProgress: '音色播放进度',
  persona: '人设与性格',
};

// 编辑态临时中文沿用户授权放在功能源码中，正式 Smartcat key 待申请。
export const temporaryMyIpEditCopy = {
  edit: '编辑 IP 设定',
  textOnly: '当前可编辑文本设定；图片、音色和其他资源保持不变。',
  name: 'IP 名称（必填）',
  summary: 'IP 描述（必填）',
  persona: '人设与性格（必填）',
  languageStyle: '语言风格（必填）',
  visualStyle: '视觉风格',
  moreSettings: '更多设定',
  settingTitle: '设定标题',
  settingContent: '设定内容',
  addSetting: '添加设定（最多 5 段）',
  removeSetting: '删除设定',
  cancel: '取消',
  save: '保存',
  saving: '保存中…',
  unsupported: '现有设定格式暂不支持编辑，原始数据未修改。',
  saveError: '保存失败，输入已保留。请重试；若版本已更新，请取消后刷新再编辑。',
  limits: {
    name: '请填写名称：中文不超过 20 字，其他语种不超过 30 词。',
    summary: '请填写描述：中文不超过 100 字，其他语种不超过 200 词。',
    persona: '请填写人设与性格，不超过 1000 字。',
    languageStyle: '请填写语言风格，不超过 1000 字。',
    visualStyle: '视觉风格不超过 1000 字。',
    moreSettings: '最多 5 段设定，请填写标题和内容，每段内容不超过 1000 字。',
    cover: '角色缺少主图，暂不能保存。',
    profile: '角色设定超过 1 MiB，请精简后保存。',
  },
};
